import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// utils
import { isColorLight } from 'utils/tree'

export const Container = styled.div`
  padding: 16px;
  overflow: auto;
`

export const Header = styled.div`
  display: flex;
  margin-right: 42px;
  padding: 16px 16px 0;
  color: ${colors.blue500};

  span {
    flex: 1;
  }

  span:nth-child(2) {
    flex: 0.7;
  }

  > :last-child {
    flex: 0;
    min-width: 90px;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 12px;
  padding: 16px;
`

export const Selected = styled.div<{ color: string }>`
  padding: 8px;
  border-radius: 6px;
  background: ${({ color }) => color};
  color: ${({ color }) => (isColorLight(color) ? colors.black : colors.white)};
`

export const Description = styled.div`
  color: ${colors.blue500};
  margin: 16px 0;
`

export const RowContainer = styled.div``

export const RowHeader = styled.div`
  padding: 8px;
  border-radius: 6px;
  font-size: 18px;
  background-color: ${colors.gray230};
  margin-bottom: 16px;
`

export const AppetitesWrapper = styled.div`
  display: flex;
  gap: 16px;
`

export const AppetiteColor = styled.div<{ color: string }>`
  border-radius: 6px;
  background: ${({ color }) => color};
  padding: 12px;
  min-width: 120px;
  text-align: center;
  color: ${({ color }) => (isColorLight(color) ? colors.black : colors.white)};
  margin-bottom: 16px;
  width: fit-content;
`

export const AppetiteText = styled.div`
  font-weight: normal;
  min-height: 44px;
  margin-bottom: 16px;
  font-size: 14px;
`
